import React, { createContext, useContext, useState, ReactNode } from 'react';

export type Pov = 'man' | 'woman';

interface PovContextValue {
  pov: Pov;
  setPov: (pov: Pov) => void;
}

const PovContext = createContext<PovContextValue | undefined>(undefined);

export const usePov = (): PovContextValue => {
  const ctx = useContext(PovContext);
  if (!ctx) {
    throw new Error('usePov must be used within PovProvider');
  }
  return ctx;
};

interface PovProviderProps {
  children: ReactNode;
  initialPov?: Pov;
}

export const PovProvider: React.FC<PovProviderProps> = ({ children, initialPov = 'man' }) => {
  const [pov, setPov] = useState<Pov>(initialPov);
  return (
    <PovContext.Provider value={{ pov, setPov }}>
      {children}
    </PovContext.Provider>
  );
};

export default PovContext;


